import * as React from 'react'
import SimpleTable from 'components/Tables/SimpleTable'
import { Link } from 'react-router'
import * as sText from 'components/Text/Text.scss'
import { compact } from 'lodash'
import * as sMarg from 'styles/modules/margins.scss'

export const ContactInfo = ({ contact, phoneNumber, showContactCreateModal }) => (
  <div className={sMarg.mb30}>
    <div className={sText.lineTitle}>Contact Details</div>
    {contact ? (
      <SimpleTable>
        <div>
          <div>Name:</div>
          <div>
            <Link to={`/dashboard/contacts/${contact.id}`}>
              {contact.firstName || contact.lastName
                ? compact([contact.firstName, contact.lastName]).join(' ')
                : contact.phoneNumbers.join(' ')}
            </Link>
          </div>
        </div>
        {contact.company && (
          <div>
            <div>Company:</div>
            <div>{contact.company}</div>
          </div>
        )}
        {contact.email && (
          <div>
            <div>Email:</div>
            <div>{contact.email}</div>
          </div>
        )}
        {contact.userId && (
          <div>
            <div>User ID:</div>
            <div>{contact.userId}</div>
          </div>
        )}
        {contact.phoneNumbers && (
          <div>
            <div>Numbers:</div>
            <div>{contact.phoneNumbers.join(' ')}</div>
          </div>
        )}
      </SimpleTable>
    ) : (
      <div>
        <SimpleTable>
          <div>
            <div>Unknown contact:</div>
            <div>
              <a onClick={() => showContactCreateModal({ phoneNumber })}>Create contact</a>
            </div>
          </div>
        </SimpleTable>
      </div>
    )}
  </div>
)



// WEBPACK FOOTER //
// src/pages/MessageThread/ContactInfo.tsx